var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.divClass(_vm.userId)},[_c('h2',[_vm._v("Profile for "+_vm._s(_vm.userId))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.getImgUrl(_vm.userId)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a209c25c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewProfile.vue
// module id = null
// module chunks = 